import styled, { css } from 'styled-components'
import { fluidSystem } from './fluid.styled'
import { theme } from './theme.styled'
import { mediaM, mediaHover, mediaShort } from './utils.styled'

export const FlexBox = styled.div`
  ${fluidSystem};
  display: flex;
  align-items: ${({ align }) => align || 'initial'};
  justify-content: ${({ justify }) => justify || 'initial'};
`

export const FluidBox = styled.div`
  ${fluidSystem};
  white-space: ${({ nowrap }) => (nowrap ? 'nowrap' : 'pre-line')};
`

export const OptionButtonTransition = styled.div`
  ${({ leaving, entering, nth, navDirection }) => css`
    opacity: ${leaving || entering ? 0 : 1};
    transform: translate(${(leaving ? -100 : entering ? 100 : 0) * navDirection}%, 0);
    transition: all 0.3s ${navDirection * nth * 0.05 + (leaving ? 0.3 : 0.4)}s;
  `};
  pointer-events: ${({ selected }) => (selected ? 'none' : 'inherit')};
`

export const OptionButtonInner = styled.div`
  position: relative;
  height: 40px;
  padding: 0 4px;
  font-size: ${theme.text.textSmall}px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid;
  border-radius: 2px;
  border-color: ${({ selected }) => theme.colors[selected ? 'primary' : 'mediumGrey']};
  background-color: ${({ selected }) => theme.colors[selected ? 'primary' : 'lightGrey']};
  color: ${({ selected }) => theme.colors[selected ? 'white' : 'body']};
  font-weight: ${theme.fontWeights.bold};
  pointer-events: ${({ selected }) => (selected ? 'none' : 'inherit')};
  transition: all 0.3s;

  ${mediaHover`
    &:hover {
      cursor: pointer;
      background-color: ${theme.colors.secondary};
      border-color: ${theme.colors.secondary};
      color: ${theme.colors.white};
    }
  `};

  ${mediaM`
    height: 60px;
  `};

  ${mediaShort`
    height: 40px;
  `};
`
export const OptionButton = ({ children, onClick, onMouseOver, onMouseOut, ...props }) => {
  const events = { onClick, onMouseOver, onMouseOut }
  return (
    <OptionButtonTransition {...props} {...events}>
      <OptionButtonInner {...props}>{children}</OptionButtonInner>
    </OptionButtonTransition>
  )
}

export const NavButton = styled.div`
  flex: 0 0 auto;
  padding: 0 16px;
  min-width: 240px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid;
  border-radius: 2px;
  text-transform: uppercase;
  font-weight: ${theme.fontWeights.bold};
  transition: all 0.3s;

  &:hover {
    cursor: pointer;
    background-color: ${({ secondary }) =>
      secondary ? theme.colors.secondary : theme.colors.primary};
    border-color: ${({ secondary }) => (secondary ? theme.colors.secondary : theme.colors.primary)};
    color: ${theme.colors.white};
  }
`

export const ResultLink = styled.div`
  ${fluidSystem};
  display: block;
  text-transform: uppercase;
  text-decoration: ${({ as }) => (as === 'a' ? 'underline' : 'none')};
  pointer-events: all;

  &:hover {
    cursor: ${({ as }) => (as === 'a' ? 'pointer' : 'default')};
  }
`
export const ChartWrapper = styled.div`
  position: relative;
  flex: 0 999 auto;
  height: 100%;
  width: 100%;

  ${({ leaving, entering }) => css`
    opacity: ${leaving || entering ? 0 : 1};
    transform: translate(0, ${leaving ? -50 : entering ? 50 : 0}%);
    transition: all 0.3s ${leaving ? 0.2 : 0.4}s;
  `};

  > .Inner {
    position: absolute;
    left: 0;
    top: 50%;
    width: 100%;
    height: 100%;
    transform: translate(0, -50%);
  }
`

export const HintWrapper = styled.div`
  ${({ leaving, entering, navDirection }) => css`
    opacity: ${leaving || entering ? 0 : 1};
    transform: translate(${(leaving ? -100 : entering ? 100 : 0) * navDirection}%, 0);
    transition: all 0.3s ${leaving ? 0.4 : 0.5}s;
  `}
`
